import Vue from 'vue';
import { ToolListModel } from '@/models/data-lake/data-lake';

Vue.filter('activityCount', (list: ToolListModel[], vendorName: string) => {
    const toolDetail = list.find((tool) => tool.toolName === vendorName);
    return toolDetail ? toolDetail.activitiesCount : 0;
});

Vue.filter('totalTimespent', (list: ToolListModel[], vendorName: string) => {
    const toolDetail = list.find((tool) => tool.toolName === vendorName);
    return toolDetail ? toolDetail.totalTimespent : 0;
});
